import React, {useEffect, useState, useContext} from 'react';
import axios from 'axios';
import classes from './SearchPage.module.scss';
import {Helmet} from "react-helmet";
import JIcon from "../../components/UI/Icon/JIcon";
import scrollToComponent from "react-scroll-to-component";
import ReactGa from "react-ga";
import Product from "../ProductCategoryPage/Products/Product/Product";
import {LoadingSimple} from "../../components/UI/LoadingBar";
import {FormattedMessage} from "react-intl";
import {Context} from "../../context/Wrapper";
import {LANG_EN} from "../../constants";

const SearchPage = (props) => {
    const context = useContext(Context)

    const [defaultOps, setDefaultOps] = useState(0)
    const [options] = useState([
        {displayId: '-Pilih-', displayValue: '-Choose Sorting-', value: 0},
        {displayId: 'Nama (A-z)', displayValue: 'Name (A-z)', value: 1},
        {displayId: 'Nama (Z-a)', displayValue: 'Name (Z-a)', value: 2},
        {displayId: 'Produk Baru', displayValue: 'New Products', value: 3},
        {displayId: 'Favorit', displayValue: 'Favourite', value: 4},
    ])
    const [listDefault, setListDefault] = useState([]);
    const [state, setState] = useState({
        done: false,
        all_products: [],
        founded_products: [],
        sorting_code: 0,
    });

    useEffect(() => {
        //=========================================================
        // useEffect 1
        //=========================================================

        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        window.scrollTo(0, 0);

        const fetchData = async () => {
            const header = {headers: {'language': context.locale}};
            const data = new FormData();
            data.append('product_name', props.match.params.id.trim());
            const getData_1 = await axios.post('product_search', data, header);
            setState({
                founded_products: getData_1.data.products,
                done: true
            });
            setListDefault(getData_1.data.products)
        }

        try {
            fetchData()
            setDefaultOps(0)
        } catch (e) {

        }

    }, [props.location.pathname, props.match.params.id, context.locale]);

    const goHome = () => {
        props.history.push('/');
    }

    const onSortHandler = (event) => {

        const value = event.target.value;
        switch (+value) {
            case (1) :
                const tempFoundedProducts0 = [...state.founded_products];
                setState({done: true, founded_products: tempFoundedProducts0.sort((a, b) => +(a.name > b.name) || -(a.name < b.name)), sorting_code: value});
                setDefaultOps(value)
                break
            case (2) :
                const tempFoundedProducts1 = [...state.founded_products];
                setState({done: true, founded_products: tempFoundedProducts1.sort((a, b) => +(a.name < b.name) || -(a.name > b.name)), sorting_code: value});
                setDefaultOps(value)
                break
            case (3) :
                const tempFoundedProducts = [...state.founded_products];
                setState({
                    done: true,
                    founded_products: tempFoundedProducts.sort((a, b) =>
                        +(a.is_new_product < b.is_new_product) || -(a.is_new_product > b.is_new_product) ||
                        -(a.is_fav_product < b.is_fav_product) || +(a.is_fav_product > b.is_fav_product)
                    ) //end .sort
                    , sorting_code: value
                });
                setDefaultOps(value)
                break
            case (4) :
                const temp2FoundedProducts = [...state.founded_products];
                setState({
                    done: true,
                    founded_products: temp2FoundedProducts.sort((a, b) =>
                        +(a.is_fav_product < b.is_fav_product) || -(a.is_fav_product > b.is_fav_product) ||
                        +(a.is_new_product < b.is_new_product) || -(a.is_new_product > b.is_new_product)
                    ) //end .sort
                    , sorting_code: value
                });
                setDefaultOps(value)
                break
            case (0) :
                setState({done: true, founded_products: listDefault, sorting_code: 0})
                setDefaultOps(value)
                break
            default :
                return null;
        }
    }

    let keywords = props.match.params.id;
    let totalFounded = 0;
    let localProducts = <LoadingSimple/>;
    if (state.founded_products !== undefined) {
        totalFounded = state.founded_products.length;
        localProducts = state.founded_products.map((prod, index) => {
            return (
                <li key={`${prod.product_cd}${index}`} className={classes.ProductsCard_row}>
                    <Product prod={prod}/>
                </li>
            );
        });
    }

    return (
        <>
            <div className={["violet", classes.SearchPage_container].join(' ')} ref={(section) => {
                scrollToComponent.Violet = section;
            }}>

                <Helmet>
                    <meta name="description" content={"Search results of Japfa Food products"}/>
                    <meta name="keywords" content="Japfa Indonesia, food service, frozen food, supplier frozen food, Best Chicken, Tokusen, Omayo, Greenfields, so good, food catering, food service delivery, meat shop, Chicken shop, food solutions, JBFS, Food Supplier"/>
                    <meta name="author" content=""/>
                    <meta property="og:title" content={keywords !== undefined ? keywords.concat(" | Search Results | Japfa Food | Indonesia | Food Supplier") : ''}/>
                    <meta property="og:description"
                          content={"Search results of Japfa Food products"}/>
                    <title>{keywords !== undefined ? keywords.concat(" | Search Results | Japfa Food | Indonesia | Food Supplier") : ''}</title>
                    <link rel="canonical" href={window.location.origin.toString() + props.location.pathname}/>
                </Helmet>

                {/*Bread crumbs region*/}
                <section className={[classes.SearchPage_sectionBread].join(' ')}>
                    <div className={["jbfs-wrapper", classes.Search_wrapperBread].join(' ')}>
                        {/*Breadcrum region*/}
                        <div className={["jbfs-breadcrumb-row",].join(' ')}>
                            <div><i onClick={() => goHome()} className="fas fa-home"/></div>
                            <span>/</span>
                            <div><FormattedMessage id={"searchpage.title"} defaultMessage={"Search Results"}/></div>
                        </div>
                        {/*Breadcrum region*/}
                    </div>
                </section>
                {/*Bread crumbs region*/}

                <section className={classes.SearchPage_sectionHeader}>
                    <div className={["jbfs-wrapper", classes.SearchPage_wrapperHeader].join(' ')}>
                        <div>
                            <h1><FormattedMessage id={"searchpage.title"} defaultMessage={"Search Results"}/></h1>
                            {/*<p>There are <span className={totalFounded < 1 ? classes.NotFound__item : null}>{totalFounded}</span> Products found in <span>"{keywords}"</span></p>*/}
                            <p><FormattedMessage id={"searchpage.description"} defaultMessage={"There are {totalFounded} Products found in {myKeywords}"}
                                                 values={{
                                                     totalFounded: <span className={totalFounded < 1 ? classes.NotFound__item : ''}>{state.founded_products && totalFounded}</span>,
                                                     myKeywords: <span>"{keywords}"</span>
                                                 }}
                            /></p>
                        </div>
                    </div>
                </section>

                <section className={classes.SearchPage_sectionContent}>
                    <div className={["jbfs-wrapper", classes.SearchPage_wrapperContent].join(' ')}>
                        <div className={classes.Sorting_row}>
                            <div className={classes.Sorting_wrapper}>
                                <div><FormattedMessage id={"global.sorting.sortby"} defaultMessage={"sort by"}/></div>
                                <div>
                                    <select className={classes.InputSelect_select}
                                            onChange={(event) => onSortHandler(event)}
                                            value={defaultOps}
                                            defaultValue={0}>
                                        {options.map((option, index) => {
                                            return <option key={index}
                                                           value={option.value}>{context.locale === LANG_EN ? option.displayValue : option.displayId}</option>
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div>
                            {!state.done ?
                                (<LoadingSimple/>)
                                :
                                (<ul className={classes.ProductsCard_wrapper}>
                                    {localProducts}
                                </ul>)
                            }
                        </div>
                    </div>

                </section>

                <div className={["jbfs-arrow-top",].join(' ')}>
                    <JIcon icontype={"link_to_top"}
                           onClick={() => scrollToComponent(scrollToComponent.Violet, {offset: -99, align: 'top', duration: 1500})}/>
                </div>
            </div>
        </>
    )
}

export default SearchPage